import { useState } from 'react';  

export default function useForm({ initialValues }) {
    const [formValues, setValues] = useState(initialValues || {});

    const handleChange = event => {
        const value = event.target.value; 
        const name = event.target.name;

        setValues({
            ...formValues,
            [name]: value
        }); 
    };
 
    return {
        handleChange,
        formValues,
        setValues
    }
}